import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	performGetRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { MST_APP_TYPE, SLACK_APP_TYPE } from '../../../../common/constants';
import type {
	AuthorizeSlackConnectionEndpointParams,
	AuthorizeConnectionResponse,
	ChatConnectionsResponse,
	OgIntegrationsResponse,
	DuplicateIntegrationParams,
	ChatSpaceTypes,
} from '../../../../common/types';

export const getConnections = (cloudId: string) => {
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/connections`;

	return performGetRequest<ChatConnectionsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getConnectionsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const getAuthorizeSlackConnectionUrl = ({
	chatSpaceId,
	cloudId,
}: AuthorizeSlackConnectionEndpointParams) => {
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/slack/connection/create?chatSpaceId=${chatSpaceId}&appType=jsm-it-service-desk&container=transition`;

	return performGetRequest<AuthorizeConnectionResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'authorizeSlackConnection',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const getOgIntegrations = (cloudId: string) => {
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integrations`;

	return performGetRequest<OgIntegrationsResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getOgIntegrationsEndpoint',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const getDelegateMSTConnectionUrl = ({
	chatSpaceId,
	cloudId,
}: AuthorizeSlackConnectionEndpointParams) => {
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/delegated?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition&createConnection=true`;

	return performGetRequest<AuthorizeConnectionResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'delegateMSTConnection',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const getaAuthorizeMSTConnectionUrl = ({
	chatSpaceId,
	cloudId,
}: AuthorizeSlackConnectionEndpointParams) => {
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorize/msteams/admin?chatSpaceId=${chatSpaceId}&appType=jsm-msteams-app&container=transition`;

	return performGetRequest<AuthorizeConnectionResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'authorizeMSTConnection',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const getUserAuthorizationUrl = ({
	cloudId,
	chatSpaceType,
	chatSpaceId,
}: AuthorizeSlackConnectionEndpointParams & { chatSpaceType: ChatSpaceTypes }) => {
	const appType = chatSpaceType === 'slack' ? SLACK_APP_TYPE : MST_APP_TYPE;
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/authorise/user?chatSpaceId=${chatSpaceId}&appType=${appType}&source=transition`;

	return performGetRequest<AuthorizeConnectionResponse>(url).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'getUserAuthorizationUrl',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};

export const duplicateIntegration = (body: DuplicateIntegrationParams) => {
	const { cloudId, id, ...restOfBody } = body;
	const url = `/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/transition/integration/duplicate/${id}`;

	return performPostRequest<AuthorizeConnectionResponse>(url, {
		body: JSON.stringify(restOfBody),
	}).catch((err) => {
		fireErrorAnalytics({
			meta: {
				id: 'duplicateIntegration',
				packageName: 'jiraEocChangeboarding',
				teamName: 'alexstrasza',
			},
			error: err,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw err;
	});
};
